export default function insertHttp(value: string) {
  return /^https?:\/\//.test(value) ? value : `http://${value}`;
}
